import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#E2FE01",   // neon green highlight
      light: "#E6FF66",
      dark: "#A6E600",
      contrastText: "#000000",
    },

    secondary: {
      main: "#1F1F23",
      light: "#2A2A2E",
      dark: "#151518",
      contrastText: "#FFFFFF",
    },

    success: {
      main: "#22C55E",
    },

    warning: {
      main: "#F59E0B",
    },

    error: {
      main: "#EF4444",
    },

    info: {
      main: "#0EA5E9",
      light:"#9ca3af",
      dark:"#2a2d35"
    },

    background: {
      default: "#F4F6F8",   // page background
      paper: "#FFFFFF",
    },

    text: {
      primary: "#111827",
      secondary: "#FFFF",
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#C6FF00",
          color: "#000",
          "&:hover": {
            backgroundColor: "#A6E600",
          },
        },
      },
    },
  },
});